import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  class: "pt-2 pl-4",
  style: {"font-weight":"bold"}
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectForm',
  props: {
    modelValue: {},
    title: {},
    items: {},
    selectedItem: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "select-form pl-4 pr-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(props.title), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 6 : 9
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, _mergeProps({
              class: "small",
              modelValue: modelValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
              items: __props.items,
              density: "compact",
              "item-title": "label",
              "item-value": "key",
              clearable: false
            }, {'return-object': true}, {
              "error-messages": props.errors
            }), null, 16, ["modelValue", "items", "error-messages"])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ]))
}
}

})